import { Controller, type Control, type FieldValues, type FieldPath } from 'react-hook-form';
import { Input } from '@schibsted-svp/react-ui';
import { MdPercent } from 'react-icons/md';
import { InputProps } from '@schibsted-svp/react-ui/lib/es/Input/Input';

type PercentInputProps<TFieldValues extends FieldValues> = {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
} & InputProps;

export function PercentInput<TFieldValues extends FieldValues>({
    name,
    control,
    ...rest
}: PercentInputProps<TFieldValues>) {
    const formatPercentValue = (value: string | undefined) => {
        return value && !Number.isNaN(Number(value)) ? (Number(value) * 100).toFixed(0) : '';
    };
    const normalizePercentValue = (value: string | undefined) => {
        return value && !Number.isNaN(Number(value)) ? (Number(value) / 100).toFixed(2).replace(/\.?0+$/, '') : '';
    };

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <Input
                    {...field}
                    value={formatPercentValue(field.value)}
                    onChange={({ currentTarget }) => {
                        field.onChange(normalizePercentValue(currentTarget.value));
                    }}
                    size="small"
                    icon={<MdPercent />}
                    iconPosition="right"
                    {...rest}
                />
            )}
        />
    );
}
